module.exports = {
  message: {
    transcodeState_QUEUED: 'QUEUED',
    transcodeState_PROCESSING: 'PROCESSING',
    transcodeState_FINISHED: 'FINISHED',
    zh: '中文',
    en: '英文'
  }
}
